import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const UiCtx = createContext(null);
const THEME_KEY = "shopbook.theme";

export function UiProvider({ children }) {
  const [theme, setThemeState] = useState(() => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem(THEME_KEY) || "light";
  });
  const [commandOpen, setCommandOpen] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const setTheme = useCallback((nextTheme) => setThemeState(nextTheme), []);
  const toggleTheme = useCallback(
    () => setThemeState((nextTheme) => (nextTheme === "dark" ? "light" : "dark")),
    []
  );

  const value = useMemo(
    () => ({
      commandOpen,
      setCommandOpen,
      setTheme,
      theme,
      toggleTheme,
    }),
    [commandOpen, setTheme, theme, toggleTheme]
  );

  return <UiCtx.Provider value={value}>{children}</UiCtx.Provider>;
}

export function useUi() {
  const ctx = useContext(UiCtx);
  if (!ctx) throw new Error("useUi must be used inside UiProvider");
  return ctx;
}
